import React from 'react';
import { CTAButton } from './CTAButton';
export const RiskAssessment = () => {
  return <section className="w-full bg-white py-10 px-4" data-id="element-344">
      <div className="max-w-4xl mx-auto" data-id="element-345">
        <div className="bg-blue-50 p-6 rounded-lg shadow-md" data-id="element-346">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-347">
            Évaluez Votre Risque Maintenant
          </h2>
          <p className="text-gray-700 mb-6 text-center" data-id="element-348">
            Répondez honnêtement à ces questions. Votre vie pourrait en
            dépendre.
          </p>
          <div className="bg-white p-6 rounded-lg mb-8" data-id="element-349">
            <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-350">
              Questions Critiques :
            </h3>
            <div className="space-y-4" data-id="element-351">
              {['Ressentez-vous des fourmillements dans les pieds le soir ou la nuit ?', "Avez-vous déjà eu l'impression de marcher sur des aiguilles ?", 'Vos pieds vous semblent-ils "engourdis" au réveil ?', "Avez-vous du mal à sentir si l'eau du bain est chaude ou froide ?", 'Vous êtes-vous déjà blessé au pied sans vous en apercevoir ?'].map((question, index) => <div key={index} className="flex items-start" data-id="element-352">
                  <div className="h-6 w-6 border border-gray-300 rounded-md flex-shrink-0 mt-1 mr-3" data-id="element-353"></div>
                  <p className="text-gray-700" data-id="element-354">{question}</p>
                </div>)}
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg mb-8" data-id="element-355">
            <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-356">
              Interprétation des Résultats :
            </h3>
            <div className="space-y-4" data-id="element-357">
              <div className="p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded" data-id="element-358">
                <p className="font-bold" data-id="element-359">
                  1-2 OUI : Stade précoce - Intervention possible
                </p>
              </div>
              <div className="p-3 bg-orange-50 border-l-4 border-orange-400 rounded" data-id="element-360">
                <p className="font-bold" data-id="element-361">
                  3-4 OUI : Zone de danger - Action urgente requise
                </p>
              </div>
              <div className="p-3 bg-red-50 border-l-4 border-red-500 rounded" data-id="element-362">
                <p className="font-bold" data-id="element-363">
                  5 OUI : Risque d'amputation élevé - Consultez immédiatement
                </p>
              </div>
            </div>
          </div>
          <p className="text-gray-700 mb-6 italic" data-id="element-364">
            Marcel avait répondu OUI à 4 questions. Trois mois plus tard, il
            perdait trois orteils.
          </p>
          <CTAButton showPrice={false} data-id="element-365" />
        </div>
      </div>
    </section>;
};